import { InputField } from "@notanumber/nan-component-library";
import { forwardRef, useEffect } from "react";
import { twMerge } from "tailwind-merge";

const InputGrinwis = (
  { type, name, label, value, customStylingOverride, dark, className, ...props },
  ref
) => {
  const is_postal_code =
  name === "postal_code" || name === "delivery_postal_code";

  const customStyling = {
    input: `w-full text-sm text-black font-normal border-transparent border rounded-5 focus:border-primary ${is_postal_code ? "input_postal_code" : ""} ${dark ? "bg-light_grey" : "bg-white"}`,
    label: `text-sm font-normal opacity-50 ${type == "textarea" ? "scale-75 -translate-y-4" : ""}`,
    container: twMerge("w-[100%]"),
    symbol: "top-[0.75rem]",
  };
  
  if (customStylingOverride) {
    Object.entries(customStylingOverride).forEach(([key, value]) => {
      customStyling[key] = twMerge(customStyling[key], value);
    });
  }

  useEffect(() => {
    // If postal_code then make letters uppercase
    if (!is_postal_code) {
      return;
    }
    const input = document.querySelector(".input_postal_code");
    if (!input) {
      return;
    }

    const listener = input.addEventListener("keyup", (e) => {
      e.target.value = e.target.value.toUpperCase();
    });

    return () => {
      input.removeEventListener("keyup", listener);
    };
  }, []);

  return (
    <div className={twMerge("flex flex-col w-full gap-2 ", className)}>
      <InputField
        ref={ref}
        type={type}
        label={label}
        defaultValue={value}
        className={customStyling}
        name={name}
        {...props}
      />
    </div>
  );
};

const InputFieldGrinwis = forwardRef(InputGrinwis);

export default InputFieldGrinwis;